import { render, staticRenderFns } from "./yygl-upload.vue?vue&type=template&id=d1ff4dfa&scoped=true&"
import script from "./yygl-upload.vue?vue&type=script&lang=js&"
export * from "./yygl-upload.vue?vue&type=script&lang=js&"
import style0 from "./yygl-upload.vue?vue&type=style&index=0&id=d1ff4dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff4dfa",
  null
  
)

export default component.exports